// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/city_geo.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/city_geo.proto.
 */
export const file_travplaces_v1_city_geo: GenFile = /*@__PURE__*/
  fileDesc("Chx0cmF2cGxhY2VzL3YxL2NpdHlfZ2VvLnByb3RvEg10cmF2cGxhY2VzLnYxIjEKB0NpdHlSZWYSCgoCaWQYASABKAkSDAoEc2x1ZxgCIAEoCRIMCgRuYW1lGAMgASgJIhcKFUdldENpdHlSZWdpb25zUmVxdWVzdCIpChZHZXRDaXR5UmVnaW9uc1Jlc3BvbnNlEg8KB2dlb2pzb24YASABKAkiXgoUQ2l0aWVzT25Sb3V0ZVJlcXVlc3QSEQoJc3RhcnRfbGF0GAEgASgBEhEKCXN0YXJ0X2xuZxgCIAEoARIPCgdlbmRfbGF0GAMgASgBEg8KB2VuZF9sbmcYBCABKAEiPwoVQ2l0aWVzT25Sb3V0ZVJlc3BvbnNlEiYKBmNpdGllcxgBIAMoCzIWLnRyYXZwbGFjZXMudjEuQ2l0eVJlZjLlAQoOQ2l0eUdlb1NlcnZpY2USagoOR2V0Q2l0eVJlZ2lvbnMSJC50cmF2cGxhY2VzLnYxLkdldENpdHlSZWdpb25zUmVxdWVzdBolLnRyYXZwbGFjZXMudjEuR2V0Q2l0eVJlZ2lvbnNSZXNwb25zZSILiuowAwoBCpDqMAESZwoNQ2l0aWVzT25Sb3V0ZRIjLnRyYXZwbGFjZXMudjEuQ2l0aWVzT25Sb3V0ZVJlcXVlc3QaJC50cmF2cGxhY2VzLnYxLkNpdGllc09uUm91dGVSZXNwb25zZSILiuowAwoBCpDqMAFCpwEKEWNvbS50cmF2cGxhY2VzLnYxQgxDaXR5R2VvUHJvdG9QAVovdHJhdnBsYWNlcy9nZW4vcHJvdG8vdHJhdnBsYWNlcy92MTt0cmF2cGxhY2VzdjGiAgNUWFiqAg1UcmF2cGxhY2VzLlYxygINVHJhdnBsYWNlc1xWMeICGVRyYXZwbGFjZXNcVjFcR1BCTWV0YWRhdGHqAg5UcmF2cGxhY2VzOjpWMWIGcHJvdG8z", [file_travplaces_v1_audit, file_travplaces_v1_authz]);

/**
 * CityRef is a lightweight city identity used by geo lookups.
 *
 * @generated from message travplaces.v1.CityRef
 */
export type CityRef = Message<"travplaces.v1.CityRef"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;
};

/**
 * Describes the message travplaces.v1.CityRef.
 * Use `create(CityRefSchema)` to create a new message.
 */
export const CityRefSchema: GenMessage<CityRef> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_city_geo, 0);

/**
 * @generated from message travplaces.v1.GetCityRegionsRequest
 */
export type GetCityRegionsRequest = Message<"travplaces.v1.GetCityRegionsRequest"> & {
};

/**
 * Describes the message travplaces.v1.GetCityRegionsRequest.
 * Use `create(GetCityRegionsRequestSchema)` to create a new message.
 */
export const GetCityRegionsRequestSchema: GenMessage<GetCityRegionsRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_city_geo, 1);

/**
 * @generated from message travplaces.v1.GetCityRegionsResponse
 */
export type GetCityRegionsResponse = Message<"travplaces.v1.GetCityRegionsResponse"> & {
  /**
   * @generated from field: string geojson = 1;
   */
  geojson: string;
};

/**
 * Describes the message travplaces.v1.GetCityRegionsResponse.
 * Use `create(GetCityRegionsResponseSchema)` to create a new message.
 */
export const GetCityRegionsResponseSchema: GenMessage<GetCityRegionsResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_city_geo, 2);

/**
 * @generated from message travplaces.v1.CitiesOnRouteRequest
 */
export type CitiesOnRouteRequest = Message<"travplaces.v1.CitiesOnRouteRequest"> & {
  /**
   * @generated from field: double start_lat = 1;
   */
  startLat: number;

  /**
   * @generated from field: double start_lng = 2;
   */
  startLng: number;

  /**
   * @generated from field: double end_lat = 3;
   */
  endLat: number;

  /**
   * @generated from field: double end_lng = 4;
   */
  endLng: number;
};

/**
 * Describes the message travplaces.v1.CitiesOnRouteRequest.
 * Use `create(CitiesOnRouteRequestSchema)` to create a new message.
 */
export const CitiesOnRouteRequestSchema: GenMessage<CitiesOnRouteRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_city_geo, 3);

/**
 * @generated from message travplaces.v1.CitiesOnRouteResponse
 */
export type CitiesOnRouteResponse = Message<"travplaces.v1.CitiesOnRouteResponse"> & {
  /**
   * @generated from field: repeated travplaces.v1.CityRef cities = 1;
   */
  cities: CityRef[];
};

/**
 * Describes the message travplaces.v1.CitiesOnRouteResponse.
 * Use `create(CitiesOnRouteResponseSchema)` to create a new message.
 */
export const CitiesOnRouteResponseSchema: GenMessage<CitiesOnRouteResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_city_geo, 4);

/**
 * CityGeoService serves city outlines and route/corridor geography.
 *
 * @generated from service travplaces.v1.CityGeoService
 */
export const CityGeoService: GenService<{
  /**
   * GetCityRegions returns a GeoJSON FeatureCollection of every city's outline
   * (bbox rectangle) as a JSON string.
   *
   * @generated from rpc travplaces.v1.CityGeoService.GetCityRegions
   */
  getCityRegions: {
    methodKind: "unary";
    input: typeof GetCityRegionsRequestSchema;
    output: typeof GetCityRegionsResponseSchema;
  },
  /**
   * CitiesOnRoute returns the cities a straight corridor between two endpoints
   * crosses (point-in-bbox on either endpoint).
   *
   * @generated from rpc travplaces.v1.CityGeoService.CitiesOnRoute
   */
  citiesOnRoute: {
    methodKind: "unary";
    input: typeof CitiesOnRouteRequestSchema;
    output: typeof CitiesOnRouteResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_city_geo, 0);

